import type { AdminPnlRecord, AdminPnlRow, AdminPnlSyncResult } from "../models/admin-pnl.models";

export function toAdminPnlRows(records: AdminPnlRecord[]): AdminPnlRow[] {
  return records.map((record) => ({
    ...record,
    gridRowId: JSON.stringify([record.TC_CODE, record.VOYAGE_NO]),
    REVIEW_RESULT:
      record.REVIEW_VISIBLE === null ? "Choose a reviewer" : record.REVIEW_VISIBLE ? "Visible" : "Not visible",
  }));
}

export function getAdminPnlSyncMessage(result: AdminPnlSyncResult): string {
  const updated = `Vessel name synced to ${result.row.CURRENT_NAME}: ${result.approvalCount} approval record(s) and ${result.summaryCount} summary record(s) updated.`;
  if (result.row.REVIEW_VISIBLE === true)
    return `${updated} The submission passes the selected reviewer's review-list checks.`;
  if (result.row.REVIEW_VISIBLE === false) return `${updated} Review still needs attention: ${result.row.DIAGNOSIS}`;
  return `${updated} Select a reviewer to check review-list visibility.`;
}

export function ignoreAdminPnlCellCommit(): void {}
